import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArchivesLogicService } from './logic/archives-types/archives-logic.service';
import { ArchivesDaoService } from './dao/archives-dao.service';
import { ArchivesStorageDaoService } from './dao/archives-dao/archives-storage-dao.service';
import { ArchivesService } from './logic/archives.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ArchivesService, useClass: ArchivesLogicService },
    {
      provide: ArchivesDaoService,
      useClass: ArchivesStorageDaoService
    }
  ]
})
export class ArchivesModule {}
